module.exports = __webpack_public_path__ + "img/pm2.27f68027.png";